import { Card, Skeleton, Stack } from '@mui/joy';

const Loader = () => {
	return (
		<Stack spacing={3}>
			{Array.from({ length: 6 }).map((_, index) => (
				<Card
					key={index}
					sx={{ py: 2, backgroundColor: 'common.white' }}
					variant='outlined'
				>
					<Skeleton variant='text' width='60%' height={20} />
					<Skeleton
						width='90%'
						height={42}
						sx={{ display: 'block' }}
						animation='wave'
						variant='rectangular'
					/>
					<Skeleton variant='text' width='30%' height={14} />
				</Card>
			))}
		</Stack>
	);
};

export default Loader;
